import { render } from "./StarIcon.vue?vue&type=template&id=09f235be"
const script = {}
script.render = render

export default script